export default "__VITE_ASSET__D8C1JI0V__"